<template>
  <div>
    <v-card class="mb-7" flat>
      <v-card-text>
        Se houverem outros lesados envolvidos, identifique-os abaixo

        <div class="mt-5">
          <!-- Estado vazio -->
          <v-card
            v-if="thirdPartyParticipants.length < 1"
            outlined
            color="#f1f1f1"
          >
            <v-card-text class="pa-10 text-center">
              Nenhum lesado identificado
            </v-card-text>
          </v-card>

          <!-- GRID DE LESADOS -->
          <v-row dense v-else>
            <v-col
              v-for="participant in thirdPartyParticipants"
              :key="participant.id"
              cols="12"
              sm="6"
              md="4"
            >
              <ParticipantCard
                :participant="participant"
                @edit="handleEditParticipant"
                @remove="handleRemoveParticipant"
              />
            </v-col>
          </v-row>
        </div>

        <!-- AÇÃO -->
        <v-list-item
          link
          class="mt-3"
          :style="{ color: insurer.color }"
          @click="handleClickAddParticipant"
        >
          <v-list-item-icon>
            <v-icon :color="insurer.color">mdi-plus</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Adicionar lesado</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-card-text>
    </v-card>

    <CreateParticipantDialog
      ref="participantDialog"
      @create="handleAddParticipant"
      @update="handleUpdateParticipant"
      :insurer="insurer"
    />
  </div>
</template>

<script>
import ParticipantCard from "./ParticipantCard.vue";
import CreateParticipantDialog from "./CreateParticipantDialog.vue";

export default {
  name: "OtherInjuredsStep",

  components: {
    ParticipantCard,
    CreateParticipantDialog,
  },

  props: {
    participants: {
      type: Array,
      required: true,
    },
    insurer: Object,
  },

  computed: {
    thirdPartyParticipants() {
      return this.participants.filter(
        (p) => p.participant_type?.canonical === "third_party"
      );
    },
  },

  methods: {
    handleClickAddParticipant() {
      this.$refs.participantDialog.open();
    },

    handleAddParticipant(participant) {
      this.$emit("update", [
        ...this.participants,
        {
          ...participant,
          id: crypto.randomUUID(),
        },
      ]);
    },

    handleEditParticipant(participant) {
      this.$refs.participantDialog.open(participant);
    },

    handleUpdateParticipant(updated) {
      this.$emit(
        "update",
        this.participants.map((p) => (p.id === updated.id ? updated : p))
      );
    },

    handleRemoveParticipant(participant) {
      if (participant.participant_type?.canonical === "insured") return;

      this.$emit(
        "update",
        this.participants.filter((p) => p.id !== participant.id)
      );
    },
  },
};
</script>
